import { Chip, styled } from '@mui/material'
import { shouldForwardProp } from '../util/helpers'

interface StatusChipProps extends Record<string, unknown> {
  textColor: string
  bgColor: string
  disableHover?: boolean
}
const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StatusChipProps>(['textColor', 'bgColor', 'disableHover'], prop),
})<StatusChipProps>`
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.01rem;
  height: 18px;
  text-transform: uppercase;
  color: ${({ textColor }) => textColor};
  background: ${({ bgColor }) => bgColor};
  padding: 4px;

  &:hover {
    color: ${({ textColor }) => textColor};
    background: ${({ bgColor }) => bgColor};
  }
`

export default StatusChip
